import React, { useMemo, useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import AuthRequiredModal from "./AuthRequiredModal";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const toTitleTR = (s = "") =>
  s
    .toLocaleLowerCase("tr")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .map((w) => (w ? w[0].toLocaleUpperCase("tr") + w.slice(1) : ""))
    .join(" ");
const Footer = ({ setCurrentPage }) => {
  const [fbFirms, setFbFirms] = useState([]);
  const [isAuthed, setIsAuthed] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setIsAuthed(!!user);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const q = query(collection(db, "firmalar"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setFbFirms(snap.docs.map((d) => d.data()));
    });
    return () => unsub();
  }, []);

  const go = (page) => {
    setCurrentPage(page);
    navigate("/");
  };

  const topSectors = useMemo(() => {
    const map = new Map();
    fbFirms.forEach((f) => {
      const sektorler = f.secilenSektorler?.length
        ? f.secilenSektorler
        : f.sektor
        ? [f.sektor]
        : [];
      sektorler.forEach((s) => {
        const label = s.trim();
        if (label) map.set(label, (map.get(label) || 0) + 1);
      });
    });
    return Array.from(map, ([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 20);
  }, [fbFirms]);

  // 20 öğeyi 4 kolona (5'erli) böl
  const columns = useMemo(() => {
    const out = [[], [], [], []];
    topSectors.forEach((item, i) => {
      out[Math.floor(i / 5)].push(item);
    });
    return out;
  }, [topSectors]);

  const handleGoCategory = (name) => {
    sessionStorage.setItem("selectedCategory", name);
    setCurrentPage?.("firms");
    // sayfan yoksa en azından en üste dönsün
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer className="bg-gradient-to-b from-gray-50 to-white">
        {/* CTA */}
        <div
          className="relative bg-cover bg-center py-16"
          style={{
            backgroundImage: `linear-gradient(rgba(251, 191, 36, 0.9), rgba(251, 191, 36, 0.9)), url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 400"><rect fill="%23fbbf24" width="1200" height="400"/><g fill="%23f59e0b" opacity="0.3"><rect x="100" y="50" width="150" height="300"/><rect x="300" y="100" width="120" height="250"/><rect x="470" y="80" width="150" height="270"/><rect x="670" y="120" width="100" height="230"/><rect x="820" y="70" width="140" height="280"/><rect x="1000" y="90" width="130" height="260"/></g></svg>')`,
          }}
        >
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-slate-800 mb-4">
              SİZ DE FİRMA REHBERİ SAYESİNDE İŞLERİNİ BÜYÜTENLERDEN OLUN
            </h2>
            <p className="text-lg text-slate-700 mb-8 max-w-3xl mx-auto">
              Sistemimize hergün onlarca farklı sektörden, onlarca farklı firma
              kayıt olmaktadır. Siz de çok geçmeden yerinizi alın.
            </p>

            <div className="flex justify-center space-x-4">
              <button
                onClick={() => {
                  if (!isAuthed) {
                    setShowAuthModal(true);
                  } else {
                    setCurrentPage("firmAdd");
                  }
                }}
                className="bg-slate-700 hover:bg-slate-800 text-white px-8 py-3 rounded-lg font-semibold transition flex items-center"
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
                HEMEN FİRMANI EKLE
              </button>
              <button className="bg-white hover:bg-gray-50 text-slate-700 px-8 py-3 rounded-lg font-semibold transition flex items-center">
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                BİLGİ ALMAK İSTİYORUM
              </button>
            </div>
          </div>
        </div>

        {/* İletişim Bandı */}
        <div className="bg-slate-700 py-4">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
              <div className="flex items-center text-white">
                <svg
                  className="w-8 h-8 mr-3 text-amber-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                  />
                </svg>
                <div>
                  <p className="font-semibold">
                    İŞLERİNİZİN BÜYÜMESİNİ SAĞLIYORUZ!
                  </p>
                  <p className="text-sm text-gray-300">
                    Hemen şimdi firmanızı kaydederek işlerinizi büyütün...
                  </p>
                </div>
              </div>

              <div className="flex justify-center">
                <button
                  onClick={() => {
                    if (!isAuthed) { setShowAuthModal(true); }
                    else { setCurrentPage("firmAdd"); }
                  }}
                  className="bg-amber-400 hover:bg-amber-500 text-slate-800 px-6 py-2 rounded-lg font-semibold transition flex items-center"
                >
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                  FİRMAMI YAYINLA
                </button>
              </div>

              <div className="flex items-center">
                <svg
                  className="w-6 h-6 mr-3 text-amber-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <div className="flex-1">
                  <p className="text-white text-sm font-semibold mb-1">
                    BÜLTENİMİZE KAYIT OLUN!
                  </p>
                  <div className="flex">
                    <input
                      type="email"
                      placeholder="E-posta adresiniz"
                      className="flex-1 px-3 py-1 rounded-l text-sm focus:outline-none"
                    />
                    <button className="bg-amber-400 hover:bg-amber-500 px-4 py-1 rounded-r transition">
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Menüler (JSON'dan 20 sektör) */}
        <div className="bg-white py-12 border-t border-gray-200">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {columns.map((col, ci) => (
                <div key={ci}>
                  <h4 className="font-semibold text-gray-800 mb-4">
                    Popüler Sektörler
                  </h4>
                  <ul className="space-y-2">
                    {col.map(({ name, count }) => (
                      <li key={name}>
                        <button
                          type="button"
                          onClick={() => handleGoCategory(name)}
                          className="w-full text-left text-gray-600 hover:text-amber-500 transition flex items-center"
                          title={`${name} (${count})`}
                          role="link"
                        >
                          <span className="w-2 h-2 bg-gray-400 rounded-full mr-2"></span>
                          {toTitleTR(name)}
                          <span className="ml-2 text-xs text-gray-400">
                            ({count})
                          </span>
                        </button>
                      </li>
                    ))}
                    {/* Eğer bu kolonda 5'ten az öğe varsa boşluk doldur (opsiyonel) */}
                    {col.length < 5 &&
                      Array.from({ length: 5 - col.length }).map((_, i) => (
                        <li key={`ghost-${ci}-${i}`} className="h-5" />
                      ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="bg-slate-800 py-4">
          <div className="container mx-auto px-4 flex items-center justify-between">
            <div className="flex items-center text-white">
              <div className="flex items-center mr-4">
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center mr-2">
                  <svg
                    className="w-5 h-5 text-slate-800"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" />
                  </svg>
                </div>
                <span className="font-semibold">İŞTESİVAS</span>
              </div>
              <span className="text-gray-400 text-sm">
                COPYRIGHT © 2026 TÜM HAKLARI SAKLIDIR.
              </span>
            </div>

            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="bg-amber-400 hover:bg-amber-500 text-slate-800 w-10 h-10 rounded flex items-center justify-center transition"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 10l7-7m0 0l7 7m-7-7v18"
                />
              </svg>
            </button>
          </div>
        </div>
      </footer>
      {showAuthModal && (
        <AuthRequiredModal
          onClose={() => setShowAuthModal(false)}
          onLogin={() => {
            setShowAuthModal(false);
            go("login");
          }}
          onRegister={() => {
            setShowAuthModal(false);
            go("register");
          }}
        />
      )}
    </>
  );
};

export default Footer;
